var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"s-cardd"},_vm._l((_vm.users),function(item){return _c('Person',{key:item.id,attrs:{"person":item},on:{"getTotalCommunity":_vm.getTotalCommunity}})}),1),_c('infinite-loading',{on:{"infinite":_vm.infiniteHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }